import TravelHeader from "./Header";
import "./index.css";
import { useState } from "react";
import { ShowHide } from "../components/ShowHideCompany";
import BusinessTravel from "./BusinessTravel";
import EPRBox from "../components/EPRBox";
import FlowNumbersBox from "../components/FlowNumbersBox";

const TravelComponent = ({ businessId, mainBusinessId }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="business-travel-container" id="travel-id">
      <TravelHeader businessId={businessId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />

        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox isNormal={true} number={"Flow 6"} color={"#193666"} />
        </div>
      </div>
      {show && (
        <EPRBox
          businessId={businessId}
          mainBusinessId={mainBusinessId}
          category={"Business Travel and Hotel Stays"}
        />
      )}
      {show && <BusinessTravel businessId={businessId} />}
    </div>
  );
};

export default TravelComponent;
